import jsonLogic from "json-logic-js";
import { difference, filter, get, isEmpty, map, size } from "lodash";
import WeightedList from 'js-weighted-list';

// Given a uniform distribution containing percentages, generate an exponential distribution
const applyExponentialDistribution = (distribution) => {
    const LAMBDA = 7.5;
    const exponential = map(get(distribution, 'input', []), item => ({
        name: item.name,
        value: LAMBDA * Math.exp(-LAMBDA * item.value),
        displayLogic: item.displayLogic,
    }));

    return exponential;
};

// Given a list of items with their probabilities, select one item using its exponential weight
const getDiscardedItems = (distribution, ctx) => {
    // Generate list of weights
    const exponential = applyExponentialDistribution(distribution);

    // Filter out those items whose predicate evaluate to false
    const filtered = filter(exponential, item => {
        return jsonLogic.apply(item.displayLogic, ctx);
    });
/*
    console.log("----------------");
    console.log("Distribution");
    console.log(distribution);
    console.log("Exponential");
    console.log(exponential);
    console.log("Filtered");
    console.log(filtered);
*/
    let discarded = [];

    // Select a sample out of the filtered list
    if (!isEmpty(filtered)) {
        const weightedList = map(filtered, item => ({ key: item.name, weight: item.value }));
        const weightList = new WeightedList(weightedList);

        // If there are not enough items then use the existing items size as limit
        const distributionLimit = get(distribution, 'limit', 1);
        const limit = distributionLimit <= size(filtered) ? distributionLimit : size(filtered);
        const weightItem = weightList.peek(limit);

        // console.log(`Item(s) selected: ${weightItem}`);

        const original = map(exponential, item => item.name);
        discarded = difference(original, weightItem);
    }
/*
    console.log("----------------");
*/
    return discarded;
};

export { getDiscardedItems };
